import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vocean',
  templateUrl: './vocean.component.html',
  styleUrls: ['./vocean.component.scss', '../../assets/partials/vocean.scss']
})
export class VoceanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
